import React, { useState } from "react";
import SelectDropdown from "../../molecules/Dropdown";
import TeamDropdownModal from "../TeamDropdownModal";
import { useSelector } from "react-redux";

const TeamDropdown = ({
  allTeams,
  teamOptions,
  onTeamListChange,
  values,
  setFieldValue,
  isError,
  refetchTeamList,
  fieldName = "assigned_teams" // New prop with default value
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const isAdmin = accessData?.role?.label === "Admin";
  const TeamManagementAccess = 
    accessData?.access?.find((module) => module.module === "Team Management") || {};
  const canEdit = isAdmin || TeamManagementAccess?.is_edit;

  // Get selected teams from form values using dynamic fieldName
  const assignedTeams = values[fieldName] || [];

  // Get option objects for currently selected team IDs from allTeams
  const selectedTeamOptions = allTeams.filter((team) =>
    assignedTeams.includes(team.value)
  );

  // Find selected teams not in teamOptions to ensure they're displayed
  const additionalSelectedOptions = selectedTeamOptions.filter(
    (selectedTeam) =>
      !teamOptions.some((option) => option.value === selectedTeam.value)
  );

  // Combine teamOptions with "Add New Team" and additional selected options
  const dropdownOptions = [
    ...(canEdit ? [{ value: "ADD_NEW_TEAM", label: "+ Add New Team", isAddNew: true }] : []),
    ...teamOptions,
    ...additionalSelectedOptions,
  ];

  const handleChange = (selectedValues) => {
    if (selectedValues.includes("ADD_NEW_TEAM")) {
      setIsModalOpen(true);
      const otherSelectedValues = selectedValues.filter(
        (val) => val !== "ADD_NEW_TEAM"
      );
      setFieldValue(fieldName, otherSelectedValues);
    } else {
      setFieldValue(fieldName, selectedValues);
    }
  };

  const handleAddNewTeam = (newTeam) => {
    onTeamListChange((prevTeams) => [...prevTeams, newTeam]);
    setFieldValue(fieldName, [...assignedTeams, newTeam.value]);
  };

  return (
    <>
      <SelectDropdown
        data={dropdownOptions}
        multiSelect={true}
        onChange={handleChange}
        selectedValue={assignedTeams}
        onClear={() => setFieldValue(fieldName, [])}
        sError={isError}
      />
      <TeamDropdownModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleAddNewTeam}
        refetchTeamList={refetchTeamList}
      />
    </>
  );
};

export default TeamDropdown;